export default {"src":"/_next/static/media/door-step.52c25486.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};